<section class="login">
  <div class="container-fluid">
    <div class="row no-padding">
      <div class="col-xs-offset-1 col-xs-10">
        <div class="login-content">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="EDP - Distribuição" />
          </div>
          <div class="user-verify">
            <h1 class="card-title text-center">Definição de Password</h1>
            <form [formGroup]="resetForm" autocomplete="off">
              <div class="form-group" *ngIf="f.pwd">
                <label for="pwd" class="font-weight-bold text-left">Insira a password:</label>
                <div class="input-group">
                  <input
                    appPasswordToggle
                    type="password"
                    class="form-control"
                    autocomplete="off"
                    formControlName="pwd"
                    id="pwd"
                    [formGroup]="resetForm"
                    placeholder="Password"
                    (input)="checkPwd($event)"
                  />
                </div>
                <div class="strength">
                  <ul id="strengthBar">
                    <li class="point" *ngFor="let bar of barArray" [style.background-color]="bar"></li>
                  </ul>
                  <p>{{ pwdLabel }}</p>
                </div>
              </div>
              <div class="form-group" *ngIf="f.confirmPwd">
                <label for="confirmPwd" class="font-weight-bold text-left">Confirme a password:</label>
                <div class="input-group">
                  <input
                    appPasswordToggle
                    type="password"
                    class="form-control"
                    autocomplete="off"
                    formControlName="confirmPwd"
                    [formGroup]="resetForm"
                    id="confirmPwd"
                    placeholder="Repetir password"
                  />
                </div>
              </div>
              <div class="form-group row no-padding">
                <div class="col-md-12">
                  <div class="text-center">
                    <button type="button" class="edp-btn btn-gray pull-left" (click)="openRules()">
                      Regras de validação
                    </button>
                    <button
                      type="submit"
                      class="edp-btn btn-yellow pull-right"
                      [disabled]="!resetForm.valid || invalidPwd"
                      (click)="onSetPassword()"
                    >
                      Submeter
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div class="row no-padding" *ngIf="invalidPwd">
              <div class="col-md-12">
                <div class="alert alert-danger text-center">
                  A password não respeita as regras, por favor introduza uma nova.
                </div>
              </div>
            </div>
            <div class="row no-padding" *ngIf="f.confirmPwd.errors && f.confirmPwd.errors.MatchPassword">
              <div class="col-md-12">
                <div class="alert alert-danger text-center">As passwords inseridas não correspondem.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
